import { render, staticRenderFns } from "./BasicPackagePrices.vue?vue&type=template&id=6ab75602&"
import script from "./BasicPackagePrices.vue?vue&type=script&lang=js&"
export * from "./BasicPackagePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports